export default defineNuxtRouteMiddleware((to) => {
  if (to.path === "/") {
    //get query params and fragment
    const { hash } = to;
    return navigateTo({ name: "shipments", hash });
  }
});
